import { Alert, BackHandler, Dimensions, Linking, View } from "react-native";
import {
  AdditionalPage,
  DrawerView,
  InputBox,
  ModalButton,
  Option,
  Separator,
} from "../accessories/accessories";
import { useEffect, useState } from "react";
import { FormatPhoneLogin, handleAPI } from "../accessories/CommonFunctions";
import CustomText from "../accessories/CustomText";
import { android, ios, web } from "../accessories/Platform";
import Icon from "react-native-vector-icons/FontAwesome";
import ChangePassword from "./ChangePassword";
import * as LocalAuthentication from "expo-local-authentication";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Swatch from "../accessories/Swatch";
import ArrowSpinner from "../accessories/ArrowSpinner";

const Settings = (props) => {
  const { From, SessionId, WebLoginId } = props.route.params;

  const { navigation } = props;
  const [details, setDetails] = useState({});
  const [drawerDetails, setDrawerDetails] = useState({
    isShow: false,
    body: <></>,
    onClose: () => {},
  });
  const handleBackAction = () => {
    navigation.navigate(From || "DashBoard");
  };
  const [statusMessage, setStatusMessage] = useState({
    isShow: false,
    messageColor: "green",
    iconName: "check",
  });
  const [isBiometricSupported, setIsBiometricSupported] = useState(false);
  const [processingStatus, setProcessingStatus] = useState(null);

  const handleSettingsDetails = async () => {
    return await handleAPI({
      name: "GetSettingsForWebLoginAccount",
      params: { WebLoginId, BioMetric: "''" },
    })
      .then(async function (response) {
        return response;
      })
      .catch(function (err) {
        console.error(`Error from GetSettingsForWebLoginAccount ====>  ${err}`);
      });
  };
  const GetDetails = async () => {
    let userDetails = await handleSettingsDetails(SessionId),
      useFaceId = false,
      BioMetricId = JSON.parse(
        (await AsyncStorage.getItem("visitorId")) || null
      );
    userDetails = JSON.parse(userDetails)["Table"];
    await AsyncStorage.setItem(
      "bioMetricLoginDetails",
      JSON.stringify(userDetails)
    );
    userDetails = userDetails[0];

    AsyncStorage.setItem("bioMetricLoginDetails", JSON.stringify(userDetails));
    try {
      let iBiometricWebLoginId = userDetails["BioMetricId"];
      iBiometricWebLoginId =
        iBiometricWebLoginId == "null" ? "" : iBiometricWebLoginId;
      useFaceId = userDetails["BioMetricId"] == BioMetricId;
      iBiometricWebLoginId ? true : false;
    } catch (error) {}

    setDetails({
      cellPhone: FormatPhoneLogin(userDetails["cellPhone"]),
      emailId: userDetails["emailId"],
      WebLoginId: userDetails["WebloginId"],
      useFaceId,
    });

    !web && setIsBiometricSupported(await isFaceIdAvailable());
  };
  useEffect(() => {
    GetDetails();
  }, [props]);
  const isFaceIdAvailable = async () => {
    const hardwareSupport = await LocalAuthentication.hasHardwareAsync(),
      available = await LocalAuthentication.supportedAuthenticationTypesAsync();

    return (
      hardwareSupport &&
      available.includes(
        LocalAuthentication.AuthenticationType[
          ios ? "FACIAL_RECOGNITION" : "FINGERPRINT"
        ]
      )
    );
  };
  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackAction
    );
    return () => backHandler.remove();
  }, []);

  const handleStatusMessage = (message, isSuccess) => {
    setStatusMessage({
      isShow: true,
      messageColor: isSuccess ? "green" : "red",
      statusMessage: message,
      iconName: isSuccess ? "check" : "close",
    });
    setTimeout(() => {
      setStatusMessage({
        isShow: false,
        messageColor: "green",
        iconName: "check",
      });
    }, 4000);
  };
  const handleSaveSettingsDetails = async (flag) => {
    let BioMetric = flag
      ? JSON.parse(await AsyncStorage.getItem("visitorId"))
      : "";

    handleAPI({
      name: "SaveFaceIdToWebLoginAccount",
      params: { WebLoginId, BioMetric },
    })
      .then(async function (response) {
        if (flag) {
          GetDetails();
          handleStatusMessage(
            `${ios ? "Face" : "Touch"} ID has been enabled for login`,
            flag
          );
        } else {
          handleStatusMessage(
            `${ios ? "Face" : "Touch"} ID has been disabled for login`,
            flag
          );
          await AsyncStorage.removeItem("bioMetricLoginDetails");
        }
        setProcessingStatus(null);
      })
      .catch(function (err) {
        console.log(`Error from SaveFaceIdToWebLoginAccount ====>  ${err}`);
      });
  };

  const handleLocalAuthentication = async () => {
    try {
      const enroll = await LocalAuthentication.isEnrolledAsync();
      if (enroll) {
        try {
          const biometricAuth = await LocalAuthentication.authenticateAsync({
            promptMessage: `Confirm your ${ios ? "Face" : "Touch"} ID`,
            disableDeviceFallback: true,
            cancelLabel: "Cancel",
          });

          if (biometricAuth.success) {
            setProcessingStatus("isSaving");
            handleSetDetails("useFaceId", true);
            handleSaveSettingsDetails(true);
          } else {
            handleSetDetails("useFaceId", false);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        Alert.alert(
          "Enable Biometrics",
          "Please enable biometrics on your device for a secure login experience.",
          [
            {
              text: "Ok",
              onPress: () => {
                if (ios) {
                  Linking.openURL("app-settings:");
                } else if (android) {
                  Linking.openSettings();
                }
              },
            },
            {
              text: "Cancel",
              onPress: () => {},
            },
          ]
        );
      }
    } catch (error) {
      Alert.alert("Error form handleLocalAuthentication", error.message);
    }
  };

  const handleSetDetails = (name, text) => {
    setDetails({ ...details, [name]: text });
  };

  return (
    <AdditionalPage
      title="Settings"
      isClose={web}
      handleBack={() => {
        web ? props.setFloatPage(null) : handleBackAction();
      }}
    >
      <Separator />
      <Separator />
      <View style={{ paddingHorizontal: 15 }}>
        <InputBox
          label="Cell Phone"
          placeholder="Enter your Cell Phone"
          keyboardType="numeric"
          onBlur={() => {
            let text = details["cellPhone"] || "";
            text = text
              .replaceAll("-", "")
              .replaceAll("(", "")
              .replaceAll(")", "")
              .replaceAll(" ", "");
            text = FormatPhoneLogin(text);
            handleSetDetails("cellPhone", text);
          }}
          onChangeText={(text) => {
            handleSetDetails("cellPhone", text);
          }}
          value={details["cellPhone"]}
        />
        <InputBox
          label="Email Address"
          placeholder="Enter your Email Address"
          onChangeText={(text) => {
            handleSetDetails("emailId", text);
          }}
          value={details["emailId"]}
        />
        {isBiometricSupported && (
          <View
            style={{
              flexDirection: "row",
            }}
          >
            <View>
              <CustomText style={{ fontSize: 16 }} bold={true}>
                Enable {ios ? "Face" : "Touch"} ID for Login
              </CustomText>
            </View>
            <View
              style={{
                position: "absolute",
                right: 0,
                flexDirection: "row",
              }}
            >
              {processingStatus == "isSaving" && (
                <View style={{ width: 20, marginRight: 5 }}>
                  <ArrowSpinner isSpinner={true} size={15} duration={1100} />
                </View>
              )}
              <Swatch
                size={12}
                value={details["useFaceId"]}
                onChange={async (value) => {
                  if (value) {
                    !details["useFaceId"] && handleLocalAuthentication();
                  } else {
                    setProcessingStatus("isSaving");
                    await AsyncStorage.removeItem("bioMetricLoginDetails");
                    await handleSaveSettingsDetails(false);
                    handleSetDetails("useFaceId", false);
                  }
                }}
              />
            </View>

            <Separator />
          </View>
        )}
        <View
          style={{
            marginTop: 20,
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <ModalButton
            onPress={(e) => {
              setDrawerDetails({
                isShow: true,
                body: <></>,

                onClose: () => {
                  setDrawerDetails({
                    isShow: false,
                    body: <></>,
                    onClose: () => {},
                  });
                },
              });
            }}
            title={
              <CustomText bold={true} style={{ fontSize: 16, color: "#fff" }}>
                Change Password
              </CustomText>
            }
          />

          <ModalButton
            onPress={(e) => {
              handleAPI({
                name: "SaveSettingsInfo",
                params: {
                  WebLoginId: details["WebLoginId"],
                  Email: details["emailId"],
                  CellPhone: details["cellPhone"],
                  // UseFaceId:details['useFaceId']
                },
              })
                .then((response) => {
                  response = JSON.parse(response)["Table"];
                  let isUserExist = response[0]["EmailExists"];
                  if (isUserExist == 1) {
                    setStatusMessage({
                      isShow: true,
                      messageColor: "red",
                      statusMessage:
                        "Entered email id already associated with another user.",
                      iconName: "close",
                    });
                  } else if (isUserExist == 0) {
                    handleStatusMessage("Details updated successfully.", true);
                  } else {
                    setStatusMessage({
                      isShow: false,
                      messageColor: "",
                      statusMessage: "",
                      iconName: "close",
                    });
                  }
                })
                .catch((error) => {});
            }}
            title={
              <CustomText bold={true} style={{ fontSize: 16, color: "#fff" }}>
                Save
              </CustomText>
            }
          />
        </View>
        <View
          style={{
            justifyContent: "space-around",
            marginTop: 20,
            alignItems: "flex-end",
          }}
        >
          {statusMessage["isShow"] ? (
            <CustomText style={{ color: statusMessage["messageColor"] }}>
              <Icon
                size={15}
                name={statusMessage["iconName"]}
                color={statusMessage["messageColor"]}
              />{" "}
              {statusMessage["statusMessage"] || ""}
            </CustomText>
          ) : (
            <CustomText> </CustomText>
          )}
        </View>
      </View>
      <DrawerView
        bodyName={android ? "android" : "ChangePassword"}
        isShow={drawerDetails["isShow"]}
        From={From || props["from"]}
        body={
          <View
            style={
              !web
                ? {
                    maxHeight: Dimensions.get("screen").height / 1.4,
                    minHeight: Dimensions.get("screen").height / 1.4,
                    flex: 1,
                    flexDirection: "row",
                  }
                : {}
            }
          >
            <ChangePassword
              WebLoginId={details["WebLoginId"]}
              closeModal={(statusMessage) => {
                handleStatusMessage(statusMessage, true);

                setDrawerDetails({
                  isShow: false,
                  body: <></>,
                  onClose: () => {},
                });
              }}
            />
          </View>
        }
        onClose={drawerDetails["onClose"]}
      />
    </AdditionalPage>
  );
};

export default Settings;
